import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"

interface UseArchiveEstablishmentProps {
  establishmentLeadId?: string
  onSuccess?: () => void
  onError?: () => void
}

export const useArchiveEstablishmentLead = ({
  establishmentLeadId,
  onSuccess,
  onError,
}: UseArchiveEstablishmentProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['archiveEstablishment'],
    mutationFn: async (newStatus: string) => {
      await privateAxios.put(`/funnel/establishment/leads/${establishmentLeadId}/${newStatus}`)
    },
    onSuccess,
    onError,
  })
}
